let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jNAJd")).then(() => parcelRequire('1mZm1'));